import wireData from "../json/wireData.json"

// https://sciencing.com/calculate-conductance-5155205.html
function getAmericanWiringCurrent(size: number, index: number) {
  const amp = wireData.find(row => row.awg === size)?.amp75degc
  return amp ? parseFloat(amp) : 0
}

function getAmericanDiameter(size: number, index: number) {
  return (0.460 * Math.pow(57 / 64, size + 3))
}

function getWireLabel(size: number, index: number) {
  return wireData.find(row => row.awg === size)?.label || size
}

function diameterToArea(n: number) {
  return ((n / 2) ** 2) * Math.PI
}

const americanSizes = Array.from(Array(44), (_, x) => x - 3);

type Column = {
  key: string,
  label: string,
  fetcher: (size: number, index: number) => React.ReactNode,
}
const columns: Column[] = [
  { key: "size", label: "Size", fetcher: (size, index) => getWireLabel(size, index) },
  { key: "wiringCurrent", label: "Max Wiring Current (A)", fetcher: (size, index) => getAmericanWiringCurrent(size, index).toFixed(3) },
  { key: "diameterIn", label: "Diameter (in)", fetcher: (size, index) => getAmericanDiameter(size, index).toFixed(5) },
  { key: "areaIn", label: "Area (in2)", fetcher: (size, index) => (diameterToArea(getAmericanDiameter(size, index))).toFixed(5) },
  { key: "diameterMm", label: "Diameter (mm)", fetcher: (size, index) => (getAmericanDiameter(size, index) * 25.4).toFixed(5) },
  { key: "areaMm", label: "Area (mm2)", fetcher: (size, index) => (diameterToArea(getAmericanDiameter(size, index) * 25.4)).toFixed(5) },
]

export default function WireSize() {
  return <div>
    <div className="text-center p-3">
      <p>
        Disclaimer: This data is provided AS IS and does not provide any warrany or liability for the accuracy or the completeness of the information and materials.
      </p>
    </div>
    <table className="w-full table-fixed">
      <thead>
        <tr>
          {columns.map(column => <td key={column.key} className="font-bold">{column.label}</td>)}
        </tr>
      </thead>
      <tbody>
        {americanSizes.map((size, index) =>
          <tr key={size} className="even:bg-gray-100 hover:bg-blue-200">
            {columns.map(column => {
              const contents = column.fetcher(size, index)
              return <td
                key={column.key}
                title={`${column.label}: ${contents}`}
              >{contents}</td>
            })}
          </tr>
        )}
      </tbody>
    </table>
  </div>
}